import $ from 'jquery'
import { gsap } from "gsap";
const navController = require('./utils/navController')
const setNavActive = require('./utils/setNavActive').init
const $document = $(document)

$document.ready(() => {

	// preloader setup
	// require('./preload')

	// kicks off the barba stuff
	// require('./barba')

	// Sample GSAP intro animation
	// gsap.from("li", 0.5, {autoAlpha:0, y:'-5', delay:0, ease:"circ.inOut", force3D:true, stagger:0.05}, 0.1)
	
	// var editing

	// $('.new-item-above').on('click', function(){
	// 	var clone = $(editing).closest('.row-item')
	// 	var cloneIndex = $(clone).attr('data-id')
	// 	console.log(clone[0])
	// 	$(clone[0].outerHTML).insertBefore(clone[0])
	// })
	
	// $('.new-item-below').on('click', function(){
	// 	var clone = $(editing).closest('.row-item')
	// 	var cloneIndex = $(clone).attr('data-id')
	// 	$(clone[0].outerHTML).insertAfter(clone[0])
	// })
	
	// $('.move-up').on('click', function(){
	// 	var clone = $(editing).closest('.row-item')[0]
	// 	if(clone.previousElementSibling)
	// 		clone.parentNode.insertBefore(clone, clone.previousElementSibling);
	// })
	
	// $('.move-down').on('click', function(){
	// 	var clone = $(editing).closest('.row-item')[0]
	// 	if(clone.nextElementSibling)
	// 		clone.parentNode.insertBefore(clone.nextElementSibling, clone);
	// })
	
	// $('.delete').on('click', function(){
	// 	var clone = $(editing).closest('.row-item')
	// 	$(clone).remove()
	// })
	
	// $(document).on('focus', '.editable', function() {
	// 	editing = this
	// 	$(this).data("initialText", $(this).html());
	// 	$('#control-bar').addClass('active')
	// 	$('body').addClass('control-bar-active')
	// }).on('blur', '.editable', function() {
	// 	if ($(this).data("initialText") !== $(this).html()) {
	// 		console.log('New data when content change.');
	// 		console.log($(this).html());
	// 	}
	// 	$('#control-bar').removeClass('active')
	// 	$('body').removeClass('control-bar-active')
	// });
	
	
})
